var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgEmailV2 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.676 7.289a.976.976 0 0 0-.978-.938H5.324a.979.979 0 0 0-.977.938c-.156 3.6-.09 5.889.017 9.355l.014.498a.974.974 0 0 0 .973.951l13.338-.009c.533 0 .96-.417.973-.946.036-1.396.147-6.222.005-9.854l.009.005ZM18.63 15.95l-3.889-3.889 3.902-3.755c.072 2.706.027 5.822-.008 7.644h-.005ZM5.387 8.031l3.684 4.222-3.658 3.658c-.084-2.844-.133-4.942-.026-7.88Zm6.573 5.227a.538.538 0 0 1-.596 0l-5.097-5.84h11.76l-6.067 5.84Zm-2.187-.2.823.942.07.067c.294.23.645.35 1 .35.356 0 .676-.106.96-.32l1.347-1.297 4.218 4.218H5.804l3.965-3.96h.004Z",
  fill: "currentColor",
  fillRule: "nonzero"
})));

const ForwardRef = /*#__PURE__*/forwardRef(SvgEmailV2);
export default ForwardRef;